import { render, staticRenderFns } from "./GridDocumento.vue?vue&type=template&id=c4b04348&"
import script from "./GridDocumento.vue?vue&type=script&lang=js&"
export * from "./GridDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports